// UdyamVerseUpdates.jsx

import React from "react";

const updates = [
  {
    dateTime: "2025-04-10T14:30",
    title: "Launch of LEGEND Digital University",
    desc: "We proudly announced the launch of LEGEND – a pioneering initiative in legal digital education."
  },
  {
    dateTime: "2025-04-08T11:00",
    title: "Faculty Board Finalized",
    desc: "Top minds from the legal and tech world join the LEGEND Faculty Advisory Board."
  },
  {
    dateTime: "2025-04-06T09:45",
    title: "Digital Campus UI Unveiled",
    desc: "A sneak peek into the sleek user interface of LEGEND's Digital Learning Campus."
  },
  {
    dateTime: "2025-04-04T17:15",
    title: "AI-Powered CLE Tools Demo",
    desc: "First look at LEGEND's Think5Whys integration for advanced legal reasoning training."
  },
  {
    dateTime: "2025-04-02T13:30",
    title: "MoU Signed with BarTech India",
    desc: "Collaboration with BarTech India ensures extended reach and legal curriculum synergy."
  },
  {
    dateTime: "2025-03-30T10:00",
    title: "Sanjeev Kumar Addresses Law Summit",
    desc: "Founder of Think5Whys shares LEGEND’s vision at the National Legal Education Summit."
  },
  {
    dateTime: "2025-03-28T16:00",
    title: "Beta Testing Begins",
    desc: "Early access to LEGEND's learning platform now available for selected users."
  },
  {
    dateTime: "2025-03-25T12:00",
    title: "First Three Certification Courses Finalized",
    desc: "Cyberlaw, Legal Design Thinking, and AI in Law now open for registration."
  },
  {
    dateTime: "2025-03-22T18:30",
    title: "Vision, Mission, Values Published",
    desc: "Read our core philosophy and commitment to legal transformation."
  },
  {
    dateTime: "2025-03-20T15:00",
    title: "Domain & Branding Secured",
    desc: "The LEGEND brand identity and domain are officially registered and secured."
  }
];

const AshramUpdates = () => {
  return (
    <section className="py-16 px-6 md:px-20 bg-gray-6000 min-h-screen">
      <h2 className="text-4xl font-bold text-center mb-12 text-orange-400">Ashram News & Updates</h2>
      <div className="space-y-6">
        {updates.map((update, idx) => (
          <div key={idx} className="bg-gray-600 rounded-lg shadow-md p-5 hover:shadow-lg transition">
            <div className="text-sm text-white mb-1">
              {new Date(update.dateTime).toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short'
              })}
            </div>
            <h3 className="text-lg font-semibold text-yellow-200">{update.title}</h3>
            <p className="text-white mt-1">{update.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AshramUpdates;
